import apiClient from 'src/utils/apiClient';
import { Modification } from 'src/types/modification';

class ModificationService {
  /**
   * get modifications
   */
  public async getModifications() {
    const res = await apiClient.get<Modification[]>('/modifications');
    return res.data;
  }

  /**
   * create or update modification
   */
  public async createOrUpdateModifications(payload: Modification) {
    const res = await apiClient.post<Modification>('/modifications', payload);
    return res.data;
  }

  /**
   * delete modification
   */
  public async deleteModification(modificationId: number) {
    await apiClient.delete(`/modifications/${modificationId}`);
  }
}

export default new ModificationService();
